import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Box } from 'reflexbox';
import { Text } from 'rebass';

import config from 'frontend/config';

const ProgressBar = ({ incompleteColor, completeColor, barText, barTextColor, pct }) => {
  let text = `${_.round(pct)}%`;
  if (barText !== null) {
    text = barText;
  }
  return (
    <Box
      style={{
        borderRadius: 20,
        backgroundColor: incompleteColor,
      }}
    >
      <Box
        style={{
          width: `${pct}%`,
          borderRadius: 20,
          backgroundColor: completeColor,
        }}
      >
        &nbsp;
        <Text small color={barTextColor} align="right" mr={1}>
          {text}
        </Text>
      </Box>
    </Box>
  );
};

ProgressBar.propTypes = {
  pct: PropTypes.number.isRequired,
  incompleteColor: PropTypes.string,
  completeColor: PropTypes.string,
  barText: PropTypes.string,
  barTextColor: PropTypes.string,
};

ProgressBar.defaultProps = {
  incompleteColor: 'rgba(0, 0, 0, 0.2)',
  completeColor: config.colors.blue,
  barTextColor: config.colors.black,
  barText: null,
};

export default ProgressBar;
